import Clip from 'assets/svgs/onboarding/clip.svg';
import Demo from 'assets/svgs/onboarding/demo.svg';
import Folder from 'assets/svgs/onboarding/folder.svg';
import Locker from 'assets/svgs/onboarding/locker.svg';
import Logo from 'assets/svgs/onboarding/logo.svg';
import Playbook from 'assets/svgs/onboarding/playbook.svg';
import Rocket from 'assets/svgs/onboarding/rocket.svg';
import Screen from 'assets/svgs/onboarding/screen.svg';
import Team from 'assets/svgs/onboarding/team.svg';
import Heart from 'assets/svgs/onboarding/favorite_border.svg';
import Speed from 'assets/svgs/onboarding/speed.svg';
import Funding from 'assets/svgs/onboarding/funding.svg';

const Icons = Object.freeze({
  clip: Clip,
  demo: Demo,
  folder: Folder,
  locker: Locker,
  logo: Logo,
  playbook: Playbook,
  rocket: Rocket,
  screen: Screen,
  team: Team,
  heart: Heart,
  speed: Speed,
  funding: Funding,
});

export const getOnboardingIcon = (name) => Icons[name] || null;
